import { CommonModule, HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { forwardRef, NgModule, PipeTransform, LOCALE_ID } from '@angular/core';
import { MatIconModule, MatPaginatorIntl, MatFormFieldModule, MatExpansionModule, MatDatepickerModule, MatNativeDateModule, MatSidenavModule, MatListModule } from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { ToasterModule } from 'angular2-toaster';
import 'hammerjs';
import { BlockUIModule } from 'ng-block-ui';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { ChartsModule } from 'ng2-charts';
import { NgxHmCarouselModule } from 'ngx-hm-carousel';
import { NgxMaskModule } from 'ngx-mask';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth/_guards';
import { AuthInterceptor } from './auth/_guards/auth.interceptor';
import { AuthModule } from './auth/_guards/auth.module';
import { IdentityStorage } from './auth/_models/identity.storage';
import { MaterialModule } from './material.module';
import { BaseComponent } from './pages/base/base.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginExternoComponent } from './pages/login/login-externo/login-externo.component';
import { CadastroDialogComponent } from "./pages/util/cadastro-dialog/cadastro-dialog.component";
import { EsqueceuSenhaDialogComponent } from "./pages/util/esqueceu-senha-dialog/esqueceu-senha-dialog.component";
import { MatPaginatorIntlPortuguese } from './pages/table-format-page/mat-paginator-int';
import { FooterComponent } from './pages/template/footer/footer.component';
import { HeaderComponent } from './pages/template/header/header.component';
import { PadraoService } from './service/padrao/padrao.service';
import { UsuarioService } from './service/usuario/usuario.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import ptBr from '@angular/common/locales/pt';
import { SolicitacaoComponent } from './pages/solicitacao/solicitacao.component';
import { PhoneFormatDirective } from './utils/input-phone-format.directive';
import { AnexarDocumentosComprobatoriosComponent } from './components/anexar-documentos-comprobatorios/anexar-documentos-comprobatorios.component';
import { NovoInscritoFormComponent } from './components/novo-inscrito-form/novo-inscrito-form.component';
import { FormularioSolicitacaoComponent } from './pages/formulario-solicitacao/formulario-solicitacao.component';
import { AuthenticationService } from './auth/_services/authentication.service';
import { MatCardModule } from '@angular/material/card';
import { DocumentoService } from './service/documento.service';
import { RelacaoInscritosComponent } from './pages/relacao-inscritos/relacao-inscritos.component';
import { FormGuard } from './auth/_guards/form.guard';
import { CadastrarEditalComponent } from './pages/cadastrar-edital/cadastrar-edital.component';
import { ListarInscritosComponent } from './pages/listar-inscritos/listar-inscritos.component';
import { ModalAtualizacaoFormComponent } from './components/modal-atualizacao-form/modal-atualizacao-form.component';
import localePt from '@angular/common/locales/pt';
import { ExcelService } from './service/excel/excel.service';
import { FormularioSolicitacaoEditarComponent } from './pages/formulario-solicitacao/editar/formulario-solicitacao-editar.component';
import {ConfirmarDialogComponent} from "./pages/util/confirmar-dialog/confirmar-dialog.component";
import {
  AnexarOutrosDocumentosComponent
} from "./components/anexar-outros-documentos/anexar-outros-documentos.component";
import { AdvogadoService } from './service/advogado/advogado.service';
import { AtivacaoTokenService } from './service/ativacaotoken/ativacao-token.service';
import { SolicitacaoAdvogadoComponent } from './pages/solicitacao-advogado/solicitacao-advogado.component';
import { TrocarSenhaDialogComponent } from './components/trocar-senha-dialog/trocar-senha-dialog.component';
import { TrocarSenhaService } from './service/trocar-senha/trocar-senha.service';
import { MatTooltipModule } from '@angular/material/tooltip';

registerLocaleData(localePt);

const globalSettings: RecaptchaSettings = {siteKey: '6Lc8vGwUAAAAAOsheXbsSd7qKpwLv0t2ECF1i___'};

registerLocaleData(ptBr, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    BaseComponent,
    LoginComponent,
    LoginExternoComponent,
    ListarInscritosComponent,
    SolicitacaoComponent,
    FormularioSolicitacaoComponent,
    PhoneFormatDirective,
    AnexarDocumentosComprobatoriosComponent,
    AnexarOutrosDocumentosComponent,
    RelacaoInscritosComponent,
    ModalAtualizacaoFormComponent,
    CadastrarEditalComponent,
    NovoInscritoFormComponent,
    FormularioSolicitacaoEditarComponent,
    ConfirmarDialogComponent,
    CadastroDialogComponent,
    EsqueceuSenhaDialogComponent,
    SolicitacaoAdvogadoComponent,
    TrocarSenhaDialogComponent
  ],
  imports: [
    MatDialogModule,
    MatIconModule,
    BrowserModule,
    MaterialModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    NgxMaskModule.forRoot(),
    BlockUIModule.forRoot(),
    ToasterModule.forRoot(),
    AuthModule,
    ChartsModule,
    NgxHmCarouselModule,
    RecaptchaModule.forRoot(),
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatExpansionModule,
    TextMaskModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatSidenavModule,
    MatListModule,
    MatTooltipModule
  ],
  providers: [
    PadraoService,
    IdentityStorage,
    AuthGuard,
    FormGuard,
    AuthenticationService,
    UsuarioService,
    DocumentoService,
    ExcelService,
    AdvogadoService,
    AtivacaoTokenService,
    TrocarSenhaService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: RECAPTCHA_SETTINGS, useValue: globalSettings },
    { provide: MatPaginatorIntl, useClass: forwardRef(() => MatPaginatorIntlPortuguese) },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
  {provide:  MatDatepickerModule, },
  ],

  entryComponents: [
    ModalAtualizacaoFormComponent, 
    NovoInscritoFormComponent, 
    ConfirmarDialogComponent,
    CadastroDialogComponent,
    EsqueceuSenhaDialogComponent,
    TrocarSenhaDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
